export const ProtocolV1 = "1";
